import { ResourceProps } from 'react-admin';
import { CommandParameterCreate } from './CommandParameterCreate';
import { CommandParameterEdit } from './CommandParameterEdit';

const commandParameters: ResourceProps = {
  name: 'command_parameters',
  create: CommandParameterCreate,
  edit: CommandParameterEdit,
  options: {
    label: 'Command Parameters',
  },
};

export default commandParameters;
